import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, MessageCircleIcon } from 'lucide-react';
import { ButtonAnchor } from './ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
import { VCARS_LOGO } from '../data/brand';
const links = [{
  label: 'Inicio',
  to: '/'
}, {
  label: 'Catálogo',
  to: '/catalogo'
}, {
  label: 'Oportunidades',
  to: '/catalogo?oportunidad=1'
}, {
  label: 'Financiación 0KM',
  to: '/financiacion'
}, {
  label: 'Vendé tu auto',
  to: '/vender-mi-auto'
}, {
  label: 'Contacto',
  to: '/contacto'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);
  return <header className={`sticky top-0 z-50 border-b transition-colors duration-200 ease-smooth ${scrolled ? 'border-neon/30 bg-ink/90 shadow-[0_10px_30px_-24px_rgba(31,123,255,0.9)] backdrop-blur-xl' : 'border-transparent bg-ink/60 backdrop-blur-md'}`} data-id="element-229" data-mp="2rl89ymqxg6yj">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center gap-6 px-5 md:h-[72px] md:px-8" data-id="element-230" data-mp="3fbvjtdkel6nq">
        <Link to="/" className="flex items-center gap-2.5" aria-label="VCARS — Inicio" data-id="element-231" data-mp="3abzffd7snd7n">
          <img src={VCARS_LOGO} alt="Logo de VCARS" className="h-10 w-10 rounded-full object-cover ring-1 ring-neon/40 md:h-11 md:w-11" data-id="element-232" data-mp="35l0x6838w51r" />
          <span className="text-lg font-black tracking-[0.18em] text-neon-soft" data-id="element-233" data-mp="1wfr8slzckzg">
            VCARS
          </span>
        </Link>

        <nav className="hidden flex-1 items-center gap-1 xl:flex" aria-label="Navegación principal" data-id="element-234" data-mp="3tavccwb1e5p6">
          {links.map(l => <NavLink key={l.label} to={l.to} end={l.to === '/'} className={({
          isActive
        }) => `rounded-lg px-3 py-2 text-[13.5px] font-medium transition-colors duration-150 ease-smooth ${isActive && l.to !== '/catalogo?oportunidad=1' ? 'text-white' : 'text-mist hover:text-white'}`} data-id="element-235" data-mp="1recxdmd3v5n5">
              {l.label}
            </NavLink>)}
        </nav>

        <div className="ml-auto flex items-center gap-2 xl:ml-0" data-id="element-236" data-mp="yovzwaamoyk2">
          <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="primary" size="sm" className="hidden lg:inline-flex" data-id="element-237" data-mp="yqqihhyfgekz">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-238" data-mp="2t3gf47g6k1w2" />
            Quiero comunicarme con un vendedor
          </ButtonAnchor>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="grid h-10 w-10 place-items-center rounded-xl border border-line bg-surface2/70 text-white xl:hidden" data-id="element-239" data-mp="meo7vatnvpol">
            {open ? <XIcon className="h-5 w-5" data-id="element-240" data-mp="rdhhut9qoyk0" /> : <MenuIcon className="h-5 w-5" data-id="element-241" data-mp="rc6eguk7hstf" />}
          </button>
        </div>
      </div>

      {open ? <div className="border-t border-line bg-ink/95 backdrop-blur-xl xl:hidden" data-id="element-242" data-mp="153bbdow6w702">
          <nav className="mx-auto flex w-full max-w-7xl flex-col px-5 py-3 md:px-8" aria-label="Navegación móvil" data-id="element-243" data-mp="105jhipbziat8">
            {links.map(l => <Link key={l.label} to={l.to} className="rounded-lg px-2 py-3 text-[15px] font-medium text-white/90 hover:bg-surface2" data-id="element-244" data-mp="1a5aaunot6jrq">
                {l.label}
              </Link>)}
            <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="primary" size="md" className="mt-3 mb-2 w-full" data-id="element-245" data-mp="22ynnbrl5r5gx">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="2cwv1k2o2b9f8" />
              Hablar con un vendedor
            </ButtonAnchor>
          </nav>
        </div> : null}
    </header>;
}